module.exports = __webpack_public_path__ + "static/crossfader-doors.1943b73f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/crossfader-doors.gif
// module id = 113
// module chunks = 118792369664667 261706647590803